import { isLocale, type Locale, localeOf } from '@porotutu/i18n'

export const LOCALE_COOKIE = 'porotutu_locale'

function cookieLocale(): Locale | null {
  for (const pair of document.cookie.split(';')) {
    const [name, ...rest] = pair.split('=')

    if (name.trim() !== LOCALE_COOKIE) continue

    const value = decodeURIComponent(rest.join('=').trim())

    if (isLocale(value)) return value
  }

  return null
}

const browserLocale = (): Locale => localeOf(navigator.language.split('-')[0])

export const guestLocale = (): Locale => cookieLocale() ?? browserLocale()

const A_YEAR = 31_536_000

export const rememberLocale = (locale: Locale) => {
  // biome-ignore lint/suspicious/noDocumentCookie: the Cookie Store API is absent from Safari and Firefox; this is one write of one cookie
  document.cookie = `${LOCALE_COOKIE}=${locale}; path=/; max-age=${A_YEAR}; samesite=lax`
}
